<!--@if (dataSource) {-->
<!--  <div>-->
<!--    <cdk-table #orgTbSort="matSort" [dataSource]="dataSource" matSort>-->
<!--      <ng-container matColumnDef="name">-->
<!--        <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[40%] h-full pl-7 py-4 font-medium" mat-sort-header> NAME-->
<!--        </cdk-header-cell>-->
<!--        <cdk-cell *cdkCellDef="let element" class="shrink-0 w-[40%] pl-7 py-1 break-words"> {{ element.name }}-->
<!--        </cdk-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="role">-->
<!--        <cdk-header-cell *cdkHeaderCellDef class="shrink-0 w-[50%] h-full py-4 font-medium" mat-sort-header>-->
<!--          BERECHTIGUNG-->
<!--        </cdk-header-cell>-->
<!--        <cdk-cell *cdkCellDef="let element"-->
<!--                  class="shrink-0 w-[50%] py-1 break-words">{{ user.roleInProjects[element.id].name | roleAndPrivileges }}-->
<!--        </cdk-cell>-->
<!--      </ng-container>-->
<!--      <ng-container matColumnDef="actions">-->
<!--        <cdk-header-cell *cdkHeaderCellDef-->
<!--                         class="flex flex-row grow w-[10%] h-full justify-end py-4 font-medium pr-4"></cdk-header-cell>-->
<!--        <cdk-cell *cdkCellDef="let element" class="flex flex-row grow w-[10%] justify-end items-center py-1 pr-4">-->
<!--          <div (click)="$event.stopPropagation()" [bicDropdownTrigger]="editProjectsDropdown"-->
<!--               class="hover:opacity-50 px-2">-->
<!--            <fa-icon [icon]="faEllipsisVertical" class="text-gray-500 text-md"></fa-icon>-->
<!--          </div>-->
<!--          <bic-dropdown #editProjectsDropdown [dropdownPlacement]="'bottom-end'">-->
<!--            <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="navigateToProjectSettings(element)">-->
<!--              <div class="flex flex-row text-sm text-gray-700">-->
<!--                <span>Bearbeiten</span>-->
<!--                <fa-icon [icon]="faPenToSquare" class="text-gray-700 text-sm ml-2"></fa-icon>-->
<!--              </div>-->
<!--            </bic-dropdown-element>-->
<!--          </bic-dropdown>-->
<!--        </cdk-cell>-->
<!--      </ng-container>-->
<!--      <cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"-->
<!--                      class="flex flex-row justify-left items-center w-full border-b-2 border-b-gray-400 bg-white rounded-t-md overflow-hidden"></cdk-header-row>-->
<!--      <cdk-row *cdkRowDef="let row; columns: displayedColumns;"-->
<!--               class="flex flex-row justify-left items-center w-full py-1 border-t-2 border-b-gray-400"></cdk-row>-->
<!--    </cdk-table>-->
<!--  </div>-->
<!--}-->

<!-- 000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 -->

<!-- src/app/components/profile/user-projects/user-projects.component.html -->

@if (dataSource?.data?.length) {
  <div class="w-full border border-gray-200 rounded-md overflow-hidden">
    <div
      class="flex flex-row justify-left items-center w-full border-b-2 border-b-gray-200 bg-gray-50 rounded-t-md overflow-hidden sticky top-0 z-10">
      <div class="shrink-0 w-[45%] h-full p-4 font-semibold text-xs text-gray-500">NAME</div>
      <div class="shrink-0 w-[45%] h-full p-4 font-semibold text-xs text-gray-500">BERECHTIGUNG</div>
      <div class="flex flex-row grow w-[10%] h-full justify-end p-4 font-medium"></div>
    </div>

    @for (element of dataSource.data; track element.id) {
      <div class="flex flex-row justify-left items-center w-full border-b border-b-gray-200 hover:bg-gray-100 transition-colors last:border-b-0">
        <div class="shrink-0 w-[45%] p-4 break-words font-medium text-sm">{{ element.name }}</div>
        <div class="shrink-0 w-[45%] p-4 break-words font-medium text-sm">{{ user.roleInProjects[element.id].name | roleAndPrivileges }}</div>

        <div class="flex flex-row grow w-[10%] justify-end items-center p-4">
          <div (click)="$event.stopPropagation()" [bicDropdownTrigger]="editProjectsDropdown" class="hover:opacity-50 px-2">
            <fa-icon [icon]="faEllipsisVertical"></fa-icon>
          </div>
          <bic-dropdown #editProjectsDropdown [dropdownPlacement]="'bottom-end'">
            <bic-dropdown-element (click)="$event.stopPropagation()" (onClick)="navigateToProjectSettings(element)">
              <div class="flex flex-row text-sm font-normal">
                <span>Bearbeiten</span><fa-icon [icon]="faPenToSquare" class="ml-2"></fa-icon>
              </div>
            </bic-dropdown-element>
          </bic-dropdown>
        </div>
      </div>
    }
  </div>
}
@else {
 <div class="border border-dashed border-gray-200 rounded-md p-6 text-center text-sm text-gray-500">
 Noch kein Projekt hinzugefügt </div>
}

@if (!dataSource) {
    <div class="p-4 text-gray-500">No projects available.</div>
}
